<ng-container *ngIf="layout === 'drawer'; else pageTpl">
  <app-form-drawer [visible]="!!basicShow" [dismissible]="false" width="min(900px, 100vw)" styleClass="inventory-form-drawer" (closed)="dialogClose()">
    <ng-container *ngIf="basicShow" [ngTemplateOutlet]="formTpl"></ng-container>
  </app-form-drawer>
</ng-container>

<ng-template #pageTpl>
  <div class="jf-page">
    <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
  </div>
</ng-template>

<ng-template #formTpl>
  <app-form-shell
    [formGroup]="inventoryForm"
    [title]="formTitle"
    [layout]="layout"
    [loading]="dataLoading"
    [missingFields]="missingFields"
    [canSave]="canSave"
    [saving]="buttonLoading"
    [saveLabel]="editInventoryId ? 'Save changes' : 'Add item'"
    (save)="save()"
    (cancel)="dialogClose()">
    <app-form-section icon="pi-box" title="Item">
      <div class="jf-grid">
        <div class="jf-field jf-col-4">
          <div class="jf-label"><span>Item type <em>*</em></span></div>
          <app-acan-select
            formControlName="itemType"
            [options]="itemTypes || []"
            optionLabel="name"
            optionValue="_id"
            [allowAdd]="true"
            addNewLabel="Add new type"
            placeholder="Select type"
            (addNew)="addItemType()"></app-acan-select>
        </div>
        <div class="jf-field jf-col-5">
          <div class="jf-label"><span>Item name <em>*</em></span></div>
          <input class="jf-input" type="text" formControlName="itemName" placeholder="e.g. Scissor lift 19ft" />
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Item no.</span></div>
          <input class="jf-input" type="text" formControlName="itemNo" placeholder="e.g. 1018" />
        </div>
        <div class="jf-field jf-col-9">
          <div class="jf-label"><span>Description <em>*</em></span></div>
          <textarea class="jf-input jf-textarea" rows="3" formControlName="description" placeholder="Condition, serial number, accessories…"></textarea>
        </div>
        <div class="jf-field jf-col-3">
          <div class="jf-label"><span>Quantity</span></div>
          <input class="jf-input" type="number" min="0" formControlName="quantity" placeholder="e.g. 1" />
        </div>
        <div class="jf-field jf-col-6" *ngIf="isWarehouse">
          <div class="jf-label"><span>Warehouse location</span></div>
          <input
            class="jf-input"
            type="text"
            formControlName="warehouseLocation"
            placeholder="Aisle / bay / bin" />
        </div>
      </div>
    </app-form-section>

    <app-form-section icon="pi-map-marker" title="Location">
      <div class="jf-grid">
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Where is it? <em>*</em></span></div>
          <div class="jf-seg ivf-status" role="radiogroup" aria-label="Item location">
            <button
              *ngFor="let s of statuses"
              type="button"
              role="radio"
              class="jf-seg__btn"
              [class.jf-seg__btn--active]="isStatusSelected(s.value)"
              [attr.aria-checked]="isStatusSelected(s.value)"
              (click)="selectStatus(s.value)">
              {{ s.name }}
            </button>
          </div>
          <p class="jf-hint" *ngIf="isWarehouse">
            <i class="pi pi-info-circle"></i> Items in the warehouse aren't linked to a client or job. Pick Drop off / On site or Pick up to add hire details.
          </p>
        </div>
      </div>
    </app-form-section>

    <ng-container *ngIf="!isWarehouse">
      <app-form-section icon="pi-user" title="Customer & job">
        <div class="jf-grid">
          <div class="jf-field jf-col-4" *ngIf="showCompanyField">
            <div class="jf-label"><span>Company <em>*</em></span></div>
            <app-acan-select
              [ngModel]="company"
              [ngModelOptions]="{ standalone: true }"
              [options]="companyNameOptions"
              [disabled]="isCompanyDisabled"
              placeholder="Select company"
              (selectionChange)="onCompanySelect($event)"></app-acan-select>
          </div>
          <div class="jf-field" [class.jf-col-4]="showCompanyField" [class.jf-col-5]="!showCompanyField">
            <div class="jf-label">
              <span>Client <em>*</em></span>
              <i class="pi pi-spin pi-spinner" *ngIf="getClientsLoading" aria-label="Loading clients"></i>
            </div>
            <app-acan-select
              formControlName="client"
              [options]="clients"
              [allowAdd]="canAddClient"
              addNewLabel="Add new client"
              [placeholder]="company ? 'Search clients' : 'Select a company first'"
              (addNew)="showClientPopup($event)"></app-acan-select>
          </div>
          <div class="jf-field" [class.jf-col-4]="showCompanyField" [class.jf-col-7]="!showCompanyField">
            <div class="jf-label">
              <span>Job <em *ngIf="needsHireDetails">*</em></span>
              <i class="pi pi-spin pi-spinner" *ngIf="getJobTitleLoading" aria-label="Loading jobs"></i>
            </div>
            <app-acan-select
              formControlName="job"
              [options]="jobTitleOptions"
              [placeholder]="inventoryForm.get('client')?.value ? (needsHireDetails ? 'Select job' : 'Optional') : 'Select a client first'"></app-acan-select>
          </div>
        </div>
      </app-form-section>

      <app-form-section icon="pi-calendar" title="Hire / dates">
        <div class="jf-grid">
          <div class="jf-field jf-col-3">
            <div class="jf-label"><span>Drop date <em>*</em></span></div>
            <p-calendar styleClass="jf-cal" formControlName="dropDate" dateFormat="dd/mm/yy" [showIcon]="true" [firstDayOfWeek]="1" [readonlyInput]="true" appendTo="body"></p-calendar>
          </div>
          <div class="jf-field jf-col-3">
            <div class="jf-label"><span>Drop time</span></div>
            <app-acan-select formControlName="dropTime" [options]="timeOptions" placeholder="Drop time"></app-acan-select>
          </div>
          <div class="jf-field jf-col-3">
            <div class="jf-label"><span>Due date <em>*</em></span></div>
            <p-calendar styleClass="jf-cal" formControlName="dueDate" dateFormat="dd/mm/yy" [showIcon]="true" [firstDayOfWeek]="1" [readonlyInput]="true" [minDate]="inventoryForm.get('dropDate')?.value" appendTo="body"></p-calendar>
          </div>
          <div class="jf-field jf-col-3">
            <div class="jf-label"><span>Dropped by</span></div>
            <app-acan-select formControlName="droppedBy" [options]="staff" optionLabel="name" placeholder="Select staff"></app-acan-select>
          </div>
        </div>
      </app-form-section>
    </ng-container>

    <app-form-section icon="pi-paperclip" title="Notes & files">
      <div class="jf-grid">
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Notes</span></div>
          <textarea class="jf-input jf-textarea" rows="3" formControlName="notes" placeholder="Internal notes…"></textarea>
        </div>
        <div class="jf-field jf-col-12">
          <div class="jf-label"><span>Attachments</span></div>
          <div class="jf-attachments">
            <p-fileUpload
              #inventoryUploader
              mode="basic"
              chooseLabel="Attach file"
              chooseIcon="pi pi-paperclip"
              accept=".zip,.pdf,.doc,.docx,.xls,.xlsx,image/*"
              [maxFileSize]="maxFileSize"
              [auto]="true"
              [customUpload]="true"
              [disabled]="isFileUploading"
              (uploadHandler)="onAttachmentUpload($event, inventoryUploader)"></p-fileUpload>
            <i class="pi pi-spin pi-spinner" *ngIf="isFileUploading" aria-label="Uploading"></i>
            <span class="jf-file" *ngFor="let file of uploadedFiles; let i = index">
              <i class="pi pi-file"></i>
              <a [href]="file.url" target="_blank" rel="noopener">{{ file.originalFileName || 'File' }}</a>
              <button type="button" (click)="renameAttachment(i)" aria-label="Rename attachment"><i class="pi pi-pencil"></i></button>
              <button type="button" (click)="removeFile($event, i)" aria-label="Remove attachment"><i class="pi pi-times"></i></button>
            </span>
          </div>
        </div>
      </div>
    </app-form-section>
  </app-form-shell>
</ng-template>

<p-confirmDialog header="Confirmation" key="removeFile" styleClass="jf-dialog" appendTo="body"></p-confirmDialog>

<p-dialog
  header="Rename attachment"
  [(visible)]="renameAttachmentDialog"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  styleClass="jf-dialog"
  [style]="{ width: '440px' }"
  [breakpoints]="{ '600px': '94vw' }">
  <form [formGroup]="renameAttachmentForm" class="jf-dialog-grid">
    <div class="jf-field jf-dialog-grid__full">
      <div class="jf-label"><span>File name <em>*</em></span></div>
      <div class="ivf-rename">
        <input class="jf-input" formControlName="fileName" placeholder="File name" />
        <input class="jf-input ivf-rename__ext" formControlName="fileExtension" />
      </div>
      <small class="jf-error" *ngIf="renameAttachmentFormErrors?.fileName?.required">File name is required.</small>
      <small class="jf-error" *ngIf="renameAttachmentFormErrors?.fileName?.error">Don't use "." or "/".</small>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="jf-btn" (click)="renameAttachmentCancel()">Cancel</button>
    <button type="button" class="jf-btn jf-btn--primary" [disabled]="renameAttachmentForm.invalid" (click)="renameAttachmentSave()">Save</button>
  </ng-template>
</p-dialog>

<app-add-edit-client-popup
  *ngIf="BasicShow"
  [basicShow]="BasicShow"
  [defaultCompanyId]="company || null"
  [initialName]="clientPopupName"
  (addClientPopupOnChange)="onAddClientPopupChange($event)">
</app-add-edit-client-popup>

<app-add-edit-item-popup
  *ngIf="isAddItemType"
  [visibleItemPopup]="isAddItemType"
  (addItemOnChange)="onAddItemChange($event)">
</app-add-edit-item-popup>
